import { memo, useImperativeHandle, useRef, forwardRef } from 'react';

import { Centered, Loader, Error } from 'components';

import { useStyles } from './style';

interface Props {
  loading: boolean;
  error: boolean;
  __html: any;
  __htmlSub: any;
  withSub: boolean;
  subLoading: boolean;
}

interface Ref {
  report: HTMLDivElement | null;
  subReport: HTMLDivElement | null;
}

let HTMLParserView = forwardRef<Ref, Props>((props, ref) => {
  const classes = useStyles();
  const { loading, error, __html, __htmlSub, withSub, subLoading } = props;
  const reportRef = useRef<HTMLDivElement | null>(null);
  const subReportRef = useRef<HTMLDivElement | null>(null);

  useImperativeHandle(ref, () => ({
    get report() {
      return reportRef.current;
    },
    get subReport() {
      return subReportRef.current;
    },
  }));

  const renderSubReport = () => (
    <div
      className={classes.report}
      style={{ overflow: 'auto' }}
      dangerouslySetInnerHTML={{ __html: __htmlSub }}
      ref={subReportRef}
    ></div>
  );

  const renderMainReport = () => (
    <div
      className={__htmlSub ? classes.report : undefined}
      dangerouslySetInnerHTML={{ __html }}
      ref={reportRef}
    ></div>
  );

  if (error) {
    return <Error />;
  }

  if (loading) {
    return (
      <Centered>
        <Loader themeColor="darkBlue" />
      </Centered>
    );
  }

  return (
    <div style={{ overflow: 'hidden', overflowX: 'auto', display: 'flex' }}>
      {__html ? renderMainReport() : null}
      {subLoading ? (
        <Centered className={classes.bindTop}>
          <Loader themeColor="darkBlue" />
        </Centered>
      ) : __htmlSub ? (
        renderSubReport()
      ) : null}
    </div>
  );
});

export default memo(HTMLParserView);
